/**
 * Sticky add-to-cart — deferred boot.
 * Expects [data-sticky-atc] with data-form-id, data-product-section-id, etc.
 * Optional slim payload: <script type="application/json" data-sticky-atc-product>
 */
(function () {
  function formatMoney(cents) {
    var currency = window.themeVendor && themeVendor.themeCurrency;
    var format =
      window.theme &&
      (theme.settings && theme.settings.currency_code_enable
        ? theme.moneyWithCurrencyFormat
        : theme.moneyFormat);
    if (currency && format) return currency.formatMoney(cents, format);
    if (window.Shopify && Shopify.formatMoney && format) return Shopify.formatMoney(cents, format);
    return (Number(cents) / 100).toFixed(2);
  }

  function initStickyAtc(bar) {
    if (!bar || bar.getAttribute('data-sticky-atc-ready') === 'true') return;
    bar.setAttribute('data-sticky-atc-ready', 'true');

    var productSection = document.getElementById(bar.getAttribute('data-product-section-id'));
    var form = document.getElementById(bar.getAttribute('data-form-id'));
    if (!productSection || !form) return;

    var hasSubs = bar.getAttribute('data-has-subs') === 'true';
    var requiresPlan = bar.getAttribute('data-requires-selling-plan') === 'true';
    var discountLabel = bar.getAttribute('data-discount-label') || '';
    var unique = bar.getAttribute('data-unique') || '';

    if (
      hasSubs &&
      !form.querySelector('[data-subscription-selectors]') &&
      !form.querySelector('[name="selling_plan"]')
    ) {
      hasSubs = false;
      bar.setAttribute('data-has-subs', 'false');
      bar.classList.remove('sticky-atc--subs');
      var orphanSubsRow = bar.querySelector('.sticky-atc__subs-row');
      if (orphanSubsRow) orphanSubsRow.hidden = true;
    }

    var sentinel = document.createElement('span');
    sentinel.setAttribute('data-sticky-atc-sentinel', '');
    sentinel.style.cssText = 'display:block;';
    form.parentNode.insertBefore(sentinel, form);

    function triggerProductAdd() {
      var atc = form.querySelector('[data-add-to-cart]');
      if (atc) {
        if (atc.disabled) return;
        atc.click();
        return;
      }
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
      } else {
        form.submit();
      }
    }

    function syncCtaAvailability(button) {
      if (!button) return;
      var atc = form.querySelector('[data-add-to-cart]');
      button.disabled = !!(atc && atc.disabled);
    }

    if (hasSubs) {
      var productData = null;
      var slimEl = bar.querySelector('[data-sticky-atc-product]');
      if (slimEl) {
        try {
          productData = JSON.parse(slimEl.textContent);
        } catch (err) {
          productData = null;
        }
      }
      if (!productData && unique) {
        var productJsonEl = document.getElementById('ProductJson-' + unique);
        try {
          productData = productJsonEl ? JSON.parse(productJsonEl.textContent) : null;
        } catch (err2) {
          productData = null;
        }
      }

      var toggleBtn = bar.querySelector('[data-sticky-subs-toggle]');
      var labelEl = bar.querySelector('[data-sticky-subs-label]');
      var freqWrap = bar.querySelector('[data-sticky-freq-wrap]');
      var freqTrigger = bar.querySelector('[data-sticky-freq-trigger]');
      var freqText = bar.querySelector('[data-sticky-freq-text]');
      var freqList = bar.querySelector('[data-sticky-freq-list]');
      var freqItems = Array.prototype.slice.call(bar.querySelectorAll('[data-plan-id]'));
      var submitBtn = bar.querySelector('[data-sticky-atc-submit]');
      var priceEl = bar.querySelector('[data-sticky-atc-price]');
      var compareEl = bar.querySelector('[data-sticky-atc-compare]');
      var syncing = false;

      var state = {
        subscribed: toggleBtn && toggleBtn.getAttribute('aria-pressed') === 'true',
        planId: null,
        groupId: null,
      };

      var activeItem = bar.querySelector('.sticky-atc__freq-item.is-active') || freqItems[0];
      if (activeItem) {
        state.planId = activeItem.getAttribute('data-plan-id');
        state.groupId = activeItem.getAttribute('data-group-id');
      }

      function setLabel() {
        if (!labelEl) return;
        if (state.subscribed) {
          labelEl.textContent = discountLabel
            ? 'Subscribed. Saving ' + discountLabel + '.'
            : 'Subscribed.';
        } else {
          labelEl.textContent = discountLabel
            ? 'Subscribe to save ' + discountLabel + ' on every order.'
            : 'Subscribe to save on every order.';
        }
      }

      function getVariant() {
        if (!productData || !productData.variants) return null;
        var idInput = form.querySelector('[name="id"]');
        var vid = idInput ? idInput.value : null;
        var match = productData.variants.find(function (variant) {
          return String(variant.id) === String(vid);
        });
        return match || productData.variants[0] || null;
      }

      function getAllocation(variant, planId) {
        if (!variant || !planId || !variant.selling_plan_allocations) return null;
        return (
          variant.selling_plan_allocations.find(function (item) {
            return String(item.selling_plan_id) === String(planId);
          }) || null
        );
      }

      function updatePrices() {
        var variant = getVariant();
        if (!variant || !priceEl) return;

        if (state.subscribed) {
          var allocation = getAllocation(variant, state.planId);
          var price = allocation ? allocation.price : variant.price;
          var compare =
            allocation && allocation.compare_at_price
              ? allocation.compare_at_price
              : variant.price;
          priceEl.textContent = ' - ' + formatMoney(price);
          if (compareEl) {
            if (compare && compare > price) {
              compareEl.textContent = formatMoney(compare);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
        } else {
          priceEl.textContent = ' - ' + formatMoney(variant.price);
          if (compareEl) {
            if (variant.compare_at_price && variant.compare_at_price > variant.price) {
              compareEl.textContent = formatMoney(variant.compare_at_price);
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
        }
      }

      function closeFreq() {
        if (!freqList || !freqTrigger) return;
        freqList.hidden = true;
        freqTrigger.setAttribute('aria-expanded', 'false');
      }

      function revealPlanGroup(groupId) {
        form.querySelectorAll('[data-group-toggle]').forEach(function (panel) {
          var match = String(panel.getAttribute('data-group-toggle')) === String(groupId || '');
          panel.classList.toggle('hidden', !match);
        });
        var description =
          form.querySelector('[data-plan-description]') ||
          productSection.querySelector('[data-plan-description]');
        if (description) {
          description.classList.toggle('hidden', !groupId);
        }
      }

      function applyToForm() {
        if (syncing) return;
        syncing = true;

        if (state.subscribed && state.planId) {
          var groupRadio = form.querySelector(
            '[name="selling-plan-group"][value="' + state.groupId + '"]'
          );
          var oneTimeRadio = form.querySelector('[name="selling-plan-group"][value=""]');
          if (oneTimeRadio) oneTimeRadio.checked = false;
          if (groupRadio) {
            groupRadio.checked = true;
            groupRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
          revealPlanGroup(state.groupId);

          var planRadio = form.querySelector('[name="selling_plan"][value="' + state.planId + '"]');
          if (planRadio) {
            planRadio.checked = true;
            planRadio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        } else if (!requiresPlan) {
          var oneTime = form.querySelector('[name="selling-plan-group"][value=""]');
          if (oneTime) {
            oneTime.checked = true;
            oneTime.dispatchEvent(new Event('change', { bubbles: true }));
          }
          form.querySelectorAll('[name="selling_plan"]').forEach(function (input) {
            if (input.checked) {
              input.checked = false;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          revealPlanGroup('');
        }

        syncing = false;
      }

      function setSubscribed(next) {
        if (requiresPlan) next = true;
        state.subscribed = !!next;
        if (toggleBtn) toggleBtn.setAttribute('aria-pressed', state.subscribed ? 'true' : 'false');
        if (freqWrap) freqWrap.hidden = !state.subscribed;
        if (!state.subscribed) closeFreq();
        setLabel();
        applyToForm();
        updatePrices();
      }

      function setPlan(planId, groupId) {
        state.planId = planId;
        state.groupId = groupId;
        freqItems.forEach(function (item) {
          var on = item.getAttribute('data-plan-id') === String(planId);
          item.classList.toggle('is-active', on);
          item.setAttribute('aria-selected', on ? 'true' : 'false');
          if (on && freqText) freqText.textContent = item.textContent.trim();
        });
        if (state.subscribed) applyToForm();
        updatePrices();
      }

      function readFormState() {
        if (syncing) return;
        var checkedPlan = form.querySelector('[name="selling_plan"]:checked');
        var oneTimeChecked = form.querySelector('[name="selling-plan-group"][value=""]:checked');
        if (checkedPlan) {
          var item = bar.querySelector('[data-plan-id="' + checkedPlan.value + '"]');
          state.subscribed = true;
          state.planId = checkedPlan.value;
          state.groupId = item ? item.getAttribute('data-group-id') : state.groupId;
          if (toggleBtn) toggleBtn.setAttribute('aria-pressed', 'true');
          if (freqWrap) freqWrap.hidden = false;
          freqItems.forEach(function (el) {
            var on = el.getAttribute('data-plan-id') === String(checkedPlan.value);
            el.classList.toggle('is-active', on);
            if (on && freqText) freqText.textContent = el.textContent.trim();
          });
        } else if (oneTimeChecked || !requiresPlan) {
          state.subscribed = false;
          if (toggleBtn) toggleBtn.setAttribute('aria-pressed', 'false');
          if (freqWrap) freqWrap.hidden = true;
          closeFreq();
        }
        setLabel();
        updatePrices();
        syncCtaAvailability(submitBtn);
      }

      if (toggleBtn) {
        toggleBtn.addEventListener('click', function () {
          if (requiresPlan) return;
          setSubscribed(!(toggleBtn.getAttribute('aria-pressed') === 'true'));
        });
      }

      if (freqTrigger && freqList) {
        freqTrigger.addEventListener('click', function (event) {
          event.stopPropagation();
          var open = freqList.hidden;
          freqList.hidden = !open;
          freqTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      freqItems.forEach(function (item) {
        item.addEventListener('click', function () {
          setPlan(item.getAttribute('data-plan-id'), item.getAttribute('data-group-id'));
          closeFreq();
        });
      });

      document.addEventListener('click', function (event) {
        if (!freqWrap || freqWrap.contains(event.target)) return;
        closeFreq();
      });

      if (submitBtn) {
        submitBtn.addEventListener('click', function () {
          applyToForm();
          triggerProductAdd();
        });
      }

      form.addEventListener('change', function (event) {
        var name = event.target && event.target.name;
        if (name === 'selling_plan' || name === 'selling-plan-group' || name === 'id') {
          readFormState();
        }
      });

      setLabel();
      applyToForm();
      updatePrices();
      syncCtaAvailability(submitBtn);

      // One deferred re-apply after theme ProductAddForm listeners attach.
      window.setTimeout(function () {
        applyToForm();
        updatePrices();
        syncCtaAvailability(submitBtn);
      }, 250);

      document.addEventListener('shopify:section:load', function (event) {
        if (event.target && event.target.contains(form)) {
          applyToForm();
          updatePrices();
          syncCtaAvailability(submitBtn);
        }
      });
    } else {
      var submitBtnSimple = bar.querySelector('[data-sticky-atc-submit]');
      var priceSlot = bar.querySelector('[data-sticky-atc-price-slot]');

      function syncPrice() {
        var source = productSection.querySelector('.product__price-and-badge');
        if (!source || !priceSlot) return;
        priceSlot.innerHTML = source.innerHTML;
      }

      syncPrice();

      var priceSource = productSection.querySelector('.product__price-and-badge');
      if (priceSource && window.MutationObserver) {
        new MutationObserver(syncPrice).observe(priceSource, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      if (submitBtnSimple) {
        submitBtnSimple.addEventListener('click', triggerProductAdd);
        syncCtaAvailability(submitBtnSimple);

        var atcBtn = form.querySelector('[data-add-to-cart]');
        if (atcBtn && window.MutationObserver) {
          new MutationObserver(function () {
            syncCtaAvailability(submitBtnSimple);
          }).observe(atcBtn, { attributes: true, attributeFilter: ['disabled'] });
        }
      }
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var mainVisible = entries[0].isIntersecting;
        bar.classList.toggle('is-visible', !mainVisible);
        bar.setAttribute('aria-hidden', mainVisible ? 'true' : 'false');
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);
  }

  function boot() {
    document.querySelectorAll('[data-sticky-atc]').forEach(initStickyAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
